export const Bio = {
  name: "Deepak",
  roles: [
    "Software Developer",
    "MERN Stack Developer",
    "Salesforce Developer",
  ],
  description:
    "A passionate software engineer with strong problem-solving skills and a solid grip on Data Structures & Algorithms, Salesforce CRM, and the MERN stack. I specialize in building scalable, high-performance web apps and CRM solutions. Actively practicing on LeetCode, with over 700 problems solved, continuously sharpening my coding and algorithmic thinking.",
  github: "https://github.com/Deepak413",
  resume:
    "https://drive.google.com/drive/folders/1QcV6rIIsPHgqAWcZafJUpwjH9T16w0KN",
  linkedin: "http://www.linkedin.com/in/deepak-dhaker",
  twitter: "http://www.linkedin.com/in/deepak-dhaker",
  insta: "https://www.instagram.com/deepak_dhaker_18/",
  facebook: "https://www.instagram.com/deepak_dhaker_18/",
  leetcode: "https://leetcode.com/DeepakDhaker/",
  gfg: "https://auth.geeksforgeeks.org/user/ddhaker2000",
  codechef:"https://www.codechef.com/users/deepak123123",
};

export const skills = [
  {
    title: "Frameworks/Libraries",
    skills: [
      {
        name: "React",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "Salesforce Lightning",
        image:
          "https://www.soliantconsulting.com/wp-content/uploads/2017/08/salesforce-lightning-experience.png", 
          
      },
      {
        name: "LWC",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTjPw-rKhH7KZH1mCTRCm5aepywg7vB_7nlQ&usqp=CAU",
      },
    ],
  },
  {
    title: "Developer Tools",
    skills: [
      {
        name: "Git",
        image:
          "https://www.20i.com/blog/wp-content/uploads/2022/08/git-blog-header.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://pbs.twimg.com/profile_images/1534945114807644173/h22f7y8F_400x400.png",
      },
      {
        name: "Salesforce.com",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRpYmVKLbaldm_F1DkP4j3xLq6C6Y-8XNq9XKf3MynMvmh96o9fJ96_ARs06D4PeG5SgeQ&usqp=CAU",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Netlify",
        image:
          "https://images.seeklogo.com/logo-png/27/1/netlify-logo-png_seeklogo-273744.png",
      },
      {
        name: "Render",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAY1BMVEX///9G47c84rQt4bGY7dKQ7NCi79ju/fg44rPC9OT3/vz6/v3p/PaI681Q5Lp76cjO9+rZ+O596smr8Nq48+BY5b3G9ecg4K4D36vT9+zj+vNo58K99OKb7tXD9OWv8d1v6MNEnehfAAADXklEQVR4nO3d23aiMBhA4RpPUesBFa0HRt//KTu9mbVif1RyDrO/a0qzJ4INOvDxAQAAAAAAAAAAAORnWm2ut93kXU1l/PRM3GhhbNNIu/kTo21+2m1r/ZfqYHg19rGUflibhUdpk2XwvGpy+UkbdKVnZqG0B2UWDqVNxmHzzs1Kd48rp3B2sc0ro3C/0tZ5JRReB0592Reease+zAvnW+l39ajwYPHeUFTh2MME5lw4rX1MYMaFlae+bAsPzqfQzAuvfg7BfAtvHgOzLPQ5g1kWHrwGZlhY+TvJ5Fk49fY2kWth7Tkwu8LxO1OolH7f0bxOsz0OBWbhl7DF0dN1mtdnGaXVZXzbVOfPd839DM2P+asZ1Hq5yWrEXW2fFip9P6QeoaPT09eoXp9TD9DZ6tkE1tXrHeTu9uS9XjepR+dD+0Go1Cn14Hxon0JVF33+/Kf1KFSXxeufLkDrsl5dUg/Nk3vLYahW/ZjBj8/WKZymHponk5Yp1L04i/5oWTXpSeqB+XJueZHWKQajVr8NRo473ckvUp3kT7UgK+CLfJZZexlxVyEKFy1TmGY1EaLwJB6GiaYwSKF8GOqNnxF3FaJQXtwrPwPuLESh+G6oXE/QtkIUiodhsj9nAhRO5RNNqlVhgEL5s4pkq6YAheLaMNlhGKJwL36YsPc04M4CFIpvh+nWTdEKk10ADlAoLn91ssU9hRYojIxCC7kVSv8boVeF97Vg57TLzAoDoLB8FJaPwvJRWD4Ky0dh+TIrPGwEbtfFMis8Cl+mHrp9Czqzwv9gjU9hdxRGRqEFCiOj0AKFkVFogcLIKLRAYWQUWqAwsv5fp7nOBG7fssusMAAKy0dh+SgsH4Xlo7B8FJYvs8LtUnBz2mVmheJd53u1Au7/Gp9CCxRGRqEFCiOj0AKFkVFogcLIKLRAYWQUWhALh70qlB7Zl64wwHWaxVziabzdiaPpyX1iAQAAgF5rpAdpfZnbaOlZW+ZNXDfSbvJ4Zpe8Aja3ER9hcjc2Ee8Knsdz1yikkEIKKaSQQgoppJBCCimkkMJ+FDbSp9xHc5uB9NHzQ6F0u/jhQ6H0qx4KxU+53a7THMaj3x7+0Rphk5F5K/izuBvzAYN7aTcjs1Dazci8oAUAAAAAAAAAAAAE8w39zlW3oYFBQgAAAABJRU5ErkJggg==",
      },
    ],
  },
  {
    title: "Languages",
    skills: [
      {
        name: "C++",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/ISO_C%2B%2B_Logo.svg/800px-ISO_C%2B%2B_Logo.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Apex",
        image:
          "https://image.pngaaa.com/135/6010135-middle.png",
      },
      {
        name: "SOQL",
        image:
          "https://img1.wsimg.com/isteam/ip/421b3f21-2085-4afa-b194-c3072be55ab1/SOQL.png",
      },
    ],
  },
  {
    title: "Courseworks/Others",
    skills: [
      {
        name: "Data Structures & Algorithms",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQP55padv4YA8XiPU_btDNiCuR8Hhb6FGt_poVPQsLJ-bfEyq5wP7egQWiJ4gQ1fWXfkZE&usqp=CAU",
          
      },
      {
        name: "OOPs",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRbsIKpiCSnAlmp5udmv0qTThkz0KjGRSfJNQ&usqp=CAU",
      },
      {
        name: "DBMS",
        image:
          "https://play-lh.googleusercontent.com/7iXp6Em_l5UMys6X_A_kw8a4QLqkvxZqz4DsqT4hNCEkKfjsUCCdmWNoePiWptTO4A",
      },
      {
        name: "CP",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/CodeChef_Logo.svg/1200px-CodeChef_Logo.svg.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://www.drupal.org/files/Capgemini_Logo_2COL_RGB.png",
    role: "Software Engineer",
    company: "Capgemini Technology Services India Limited",
    date: "Nov 2023 - present (2+ years)",
    desc:"Automated business workflows using Apex classes, triggers, and flows, reducing manual effort by 90%. Built custom objects and relationships to streamline onboarding, cutting time by 30%. Resolved critical production issues, decreasing bug resolution time from 3 days to 12 hours. Collaborated in Agile sprints to deliver scalable Salesforce features, leveraging Git, VS Code, and SFDX.",
    skills: [
      "LWC",
      "Apex",
      "Salesforce Lightning",
      "SOQL",
      "CRM",
      "JavaScript",
      "HTML",
      "CSS",
    ],
  },
  {
    id: 1,
    img: "https://www.drupal.org/files/Capgemini_Logo_2COL_RGB.png",
    role: "Salesforce Developer Intern",
    company: "Capgemini Technology Services India Limited",
    date: "Feb 2023 - May 2023",
    desc: "Worked on Salesforce development tasks, including Apex programming, Lightning components, and process automation. Gained hands-on experience with CRM customization, data management, and Agile team collaboration.",
    skills: [
      "LWC",
      "Apex",
      "Salesforce Lightning",
      "SOQL",
      "CRM",
      "JavaScript",
    ],
  },
];

export const education = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRyk_DXxv0zgLdL1mmF1bY9Kdd3YTWZ6n2W4Q&usqp=CAU",
    school: "Chandigarh University, Punjab",
    date: "2019 - 2023",
    grade: "7.48 CGPA",
    desc: "Completed a comprehensive undergraduate program with a strong focus on software development and problem-solving. Gained hands-on experience through coursework in C++ Programming, Data Structures & Algorithms, DBMS, Object-Oriented Programming, and Mathematics, laying a solid foundation for building efficient and scalable software solutions.",
    degree: "BTech, Computer Science and Engineering",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQYD9WyZCMbhcW_04Fjxt0GUoZUIoKmBKVw9A&usqp=CAU",
    school: "Jawahar Navodaya Vidyalaya, Bhilwara, Rajasthan (JNV)",
    date: "July 2011 - May 2018",
    grade: "81.67%",
    desc: "Completed Class 12th education at Jawahar Navodaya Vidyalaya (JNV), Bhilwara, with a focus on Mathematics and Computer Science. Developed a strong analytical foundation and early interest in programming, which led to further studies in Computer Science.",
    degree: "CBSE(XII), Maths with Computer Science",
  },
];

export const projects = [
  {
    id: 9,
    title: "ShoppingKaro",
    date: "jan 2024 - May 2024",
    description:
      "Built a full-stack eCommerce website with over 20 pages, featuring JWT authentication, role-based access, and a responsive UI using React, Redux, and React Router. Developed a dynamic product catalog with filtering, search, pagination, and detailed product pages with reviews and ratings. Integrated cart management, CRUD operations, and Stripe for seamless checkout. Enabled user registration, login, profile updates, and order management. Enhanced UX with in-app notifications and validation popups, implemented security with data validation and bcrypt password hashing, and optimized image delivery using Cloudinary CDN.",
    image:
      "https://private-user-images.githubusercontent.com/98450154/471259790-63bff356-2dba-4e47-b099-295a1fbaa6e3.png?jwt=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJnaXRodWIuY29tIiwiYXVkIjoicmF3LmdpdGh1YnVzZXJjb250ZW50LmNvbSIsImtleSI6ImtleTUiLCJleHAiOjE3NzI0Nzg2MTYsIm5iZiI6MTc3MjQ3ODMxNiwicGF0aCI6Ii85ODQ1MDE1NC80NzEyNTk3OTAtNjNiZmYzNTYtMmRiYS00ZTQ3LWIwOTktMjk1YTFmYmFhNmUzLnBuZz9YLUFtei1BbGdvcml0aG09QVdTNC1ITUFDLVNIQTI1NiZYLUFtei1DcmVkZW50aWFsPUFLSUFWQ09EWUxTQTUzUFFLNFpBJTJGMjAyNjAzMDIlMkZ1cy1lYXN0LTElMkZzMyUyRmF3czRfcmVxdWVzdCZYLUFtei1EYXRlPTIwMjYwMzAyVDE5MDUxNlomWC1BbXotRXhwaXJlcz0zMDAmWC1BbXotU2lnbmF0dXJlPWQxMjMzZjc0MzZlN2VlZTkyNDRlOWEzNjM4ODQ3MWU0NmE4MjBmN2U2OWUyNDk1NGYxMzMxNjVhOWIyY2RjMDcmWC1BbXotU2lnbmVkSGVhZGVycz1ob3N0In0.x5oOVVr2tFTRB3nAMZ3kMIAS0oF7N2_EJLe3YpR1Vj4",
    tags: [
      "React Js",
      "JavaScript",
      "Node Js",
      "Express Js",
      "MongoDb",
      "Redux",
      "bcrypt & jwt",
      "axios",
      "Stripe",
      "cloudinary",
    ],
    category: "fullstack",
    github: "https://github.com/Deepak413/MyEcommerceStore",
    webapp: "https://shoppinggkaro.netlify.app/",
  },
  {
    id: 8,
    title: "JustDance",
    date: "May 2023 - June 2023",
    description:
      "JustDance is a fullstack dance website built using MERN technologies where user can checkout dance classes and related information. The website also contain login/registeration with proper authentication.",
    image:
      "https://user-images.githubusercontent.com/98450154/268307862-6622b8b2-13ae-4398-8366-da788f439447.png",
    tags: [
      "React Js",
      "JavaScript",
      "Node Js",
      "Express Js",
      "MongoDb",
      "Redux",
      "HTML & CSS",
      "bcrypt & jwt",
    ],
    category: "fullstack",
    github: "https://github.com/Deepak413/MERN-dance-website-d",
    webapp: "https://mern-dance-website-d.vercel.app/",
  },
  {
    id: 2,
    title: "Gym Website",
    date: "May 2023 - May 2023",
    description:
      "Developed a responsive gym website to provide information about gym facilities, trainers and classes",
    image:
      "https://user-images.githubusercontent.com/98450154/268471748-70ba8b02-a0fc-4d96-8f96-261fc11a9897.png",
    tags: ["React", "Routers", "Material-UI"],
    category: "frontend",
    github: "https://github.com/Deepak413/gym-responsive-REACT-website/tree/main",
    webapp: "https://deepak413.github.io/gym-responsive-REACT-website/",
  },
  {
    id: 0,
    title: "WeatherFinder",
    date: "April 2022 - May 2022",
    description:
      "Developed a responsive weather application to check current weather and check for different locations using data fetched from OpenWeatherMap API",
    image:
      "https://user-images.githubusercontent.com/98450154/268471041-ab450e72-b3bd-4835-bee5-72ecfeb3183e.png",
    tags: ["Node Js", "Express Js", "HTML", "CSS", "OpenWeatherMap API", "Handlebars"],
    category: "fullstack",
    github: "https://github.com/Deepak413/weatherfinder",
    webapp: "https://weatherfinder-iyk8.onrender.com",
  },
  {
    id: 1,
    title: "Lets Travel",
    date: "Oct 2022 - Present",
    description:
      "Designed and developed the Travel and Tourism Website that helps users to checkout all the travel destinations. Also Login and Signup functionality available.",
    image:
      "https://user-images.githubusercontent.com/98450154/268471314-21381bc6-e3d1-4e98-88b4-09cf20a4f633.png",
    tags: [
      "Node Js",
      "Express Js",
      "MongoDb",
      "HTML & CSS",
      "Render",
    ],
    category: "fullstack",
    github: "https://github.com/Deepak413/TravelWebsite",
    webapp: "https://lets-travel-yxct.onrender.com",
  },
  {
    id: 3,
    title: "KeepSafe",
    date: "Feb 2023 - Feb 2023",
    description:
      "Developed a google-keep-clone to store user's to-do tasks. Add and Delete functionality available.",
    image:
      "https://user-images.githubusercontent.com/98450154/268472307-d3926b92-06cf-47bf-bf35-243f13f85408.png",
    tags: ["React", "JavaScript", "Redux", "material-UI"],
    category: "frontend",
    github: "https://github.com/Deepak413/keepsafe",
    webapp: "https://deepak413.github.io/keepsafe/",
  },
  {
    id: 7,
    title: "My Portfolio",
    date: "Aug 2023 - Sept 2023",
    description:
      "Developed this portfolio to demonstrate my skills and expertise, my educational and professional journey, accomplishments, and to provide tangible evidence of my qualifications and work.",
    image:
      "https://private-user-images.githubusercontent.com/98450154/268494906-9db0cf47-fca7-41d0-a30c-f0ba9c23d383.png?jwt=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJnaXRodWIuY29tIiwiYXVkIjoicmF3LmdpdGh1YnVzZXJjb250ZW50LmNvbSIsImtleSI6ImtleTUiLCJleHAiOjE3NTM2NTI4MDcsIm5iZiI6MTc1MzY1MjUwNywicGF0aCI6Ii85ODQ1MDE1NC8yNjg0OTQ5MDYtOWRiMGNmNDctZmNhNy00MWQwLWEzMGMtZjBiYTljMjNkMzgzLnBuZz9YLUFtei1BbGdvcml0aG09QVdTNC1ITUFDLVNIQTI1NiZYLUFtei1DcmVkZW50aWFsPUFLSUFWQ09EWUxTQTUzUFFLNFpBJTJGMjAyNTA3MjclMkZ1cy1lYXN0LTElMkZzMyUyRmF3czRfcmVxdWVzdCZYLUFtei1EYXRlPTIwMjUwNzI3VDIxNDE0N1omWC1BbXotRXhwaXJlcz0zMDAmWC1BbXotU2lnbmF0dXJlPTI4YTc1ZjM0YmNmNTQ4YzdjZWYyM2IzN2M4MGFhMTVhZDNmMjdlMjZjNTUzOWNjMTMwNjRmMjUyMWQ5MGY1MmUmWC1BbXotU2lnbmVkSGVhZGVycz1ob3N0In0.cFBW6YHLJpBUGWTzBthi1EbGrhuArKHvOiS1wgCDEU0",
    tags: ["Reactjs", "JavaScript", "Router", "Emailjs"],
    category: "frontend",
    github: "https://github.com/Deepak413/Deepak-Dhaker-Portfolio",
    webapp: "https://deepak413.github.io/Deepak-Dhaker-Portfolio/",
  },
  {
    id: 4,
    title: "HungrySnake",
    date: "Jul 2020",
    description:
      "Build a snake Game with high score functionality.",
    image:
      "https://user-images.githubusercontent.com/98450154/268472391-a97915a3-3204-4fe7-ad06-d46ea988e173.png",
    tags: ["Javascript", "HTML", "CSS"],
    category: "basic web",
    github: "https://github.com/Deepak413/hungrysnake.github.io",
    webapp: "https://deepak413.github.io/hungrysnake.github.io/",
  },
  {
    id: 5,
    title: "Todo Web App",
    date: "Dec 2022",
    description:
      " A Todo Web App made with React JS, and Material UI. It has a sidebar where users can see all the tasks and can create a new task.",
    image:
      "https://user-images.githubusercontent.com/98450154/268472503-32c7b5f0-79d7-497d-8c42-0c4b18591447.png",
    tags: ["React Js", "Local Storage"],
    category: "basic web",
    github: "https://github.com/Deepak413/todolistD",
    webapp: "https://deepak413.github.io/todolistD/",
  },
  {
    id: 6,
    title: "Restaurant Website",
    date: "Jan 2023",
    description:
      "A simple Restaurant web app that contain Home, Orders, About and Contact pages.",
    image:
      "https://user-images.githubusercontent.com/98450154/268472672-7b503851-8620-4852-a813-e1c37b4c5db4.png",
    tags: ["React Js", "API", "Router"],
    category: "basic web",
    github: "https://github.com/Deepak413/Restaurant-react-website",
    webapp: "https://deepak413.github.io/Restaurant-react-website/",
  },
];
